import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ClickOutside from 'vuetify/lib/directives/click-outside';
import Intersect from 'vuetify/lib/directives/intersect';
import Ripple from 'vuetify/lib/directives/ripple';

import config from './config';

Vue.use(Vuetify, {
    directives: {
        ClickOutside,
        Intersect,
        Ripple,
    },
});

export default new Vuetify(config);
